<form class="edit-modal kw-dialog" (ngSubmit)="onSubmit()" #editForm="ngForm">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{this.reasonCode.id ? 'Edit' : 'New'}} {{"Reason Code" | tenantWords}}</h2>
      <div class="modal-subtitle" *ngIf="this.reasonCode.id">{{this.data?.reasonCode?.reason}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isSubmitting">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faListCheck" class="section-icon"></fa-icon>
        <h3>Details</h3>
      </div>
      <mat-form-field appearance="outline" class="code-field">
        <mat-label>Code</mat-label>
        <input required matInput [(ngModel)]="reasonCode.reason" name="reasonInput" cdkFocusInitial>
        <mat-error>Code is required</mat-error>
      </mat-form-field>
    </section>
  </div>

  <div class="modal-footer">
    <button *ngIf="this.reasonCode.id" mat-stroked-button class="danger-btn" type="button"
      [disabled]="this.isSubmitting" (click)="onDelete()">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Delete
    </button>
    <span class="footer-spacer"></span>
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="editForm.invalid || this.isSubmitting">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</form>
